//
//
//
//
//
//
//
//
//
//
//

import AQUploader from "@/components/Generics/AQUploader/AQUploader.vue";

const { Interface, FunctionFragment } = require("ethers/lib/utils");

export default {
    name: "UploadAbiFile",
    components: { AQUploader },
    data() {
        return {
            fileName: null
        };
    },

    methods: {
        removedFiles() {
            this.$emit("sendAbiData", { data: null, fileName: null, abiData: null });
        },
        parseData(data) {
            this.fileName = data[0].name;
            const fr = new FileReader();
            fr.readAsBinaryString(data[0]);
            fr.onloadend = () => {
                const data2 = JSON.parse(fr.result);
                const parsedData = this.parseAbi(data2);
                this.$emit("sendAbiData", { data: parsedData, fileName: this.fileName, abiData: data2 });
            };
        },
        parseAbi(abi) {
            const intf = new Interface(abi);
            return this.parseFragments(intf.fragments);
        },
        parseFragments(fragments) {
            const methods = [];
            fragments.forEach((fragment, index) => {
                if (fragment.type === "function") {
                    const fnFrag = FunctionFragment.from(fragment);
                    const fnFragName = fnFrag.name || `field${index + 1}`;
                    methods.push({
                        name: fnFragName,
                        path: fnFragName,
                        type: fnFrag.constant === false
                    && (fnFrag.stateMutability === "nonpayable" || fnFrag.stateMutability === "payable")
                            ? "transaction" : "call",
                        inputs: this.parseParams(fnFrag.inputs),
                        outputs: this.parseParams(fnFrag.outputs),
                        gas: fnFrag.gas
                    });
                }
            });
            return methods;
        },
        parseParams(params, parentPath) {
            if (params && Array.isArray(params) && params.length > 0) {
                return params.map((param, index) => {
                    const paramName = param.name || `field${index + 1}`;
                    const path = parentPath ? `${parentPath}.${paramName}` : paramName;
                    return {
                        name: paramName,
                        path,
                        type: this.getContentType(param),
                        isList: param.baseType === "array",
                        fields: this.getFields(param, path),
                        arrayLength: param.arrayLength
                    };
                });
            }
            return [];
        },
        getContentType(param) {
            const { baseType } = param;
            let contentType;

            if (baseType === "tuple") {
                contentType = "object";
            } else {
                contentType = baseType === "array" ? this.getContentType(param.arrayChildren) : this.convertType(param.baseType);
            }

            return contentType;
        },

        getFields(param, parentPath) {
            return this.getContentType(param) === "object"
                ? this.parseParams(param.components, parentPath) : null;
        },
        convertType(type) {
            if (type === "string" || type === "address" || type.includes("bytes")) return "string";
            if (type.includes("int")) return "integer";
            if (type === "bool") return "boolean";
            return type;
        }

    }
};
